import React from "react";
import {useNavigate} from "react-router-dom";
import {ASSET_LEASE_HEADER} from "../../../../components/table/header/Headers";
import useRequestData from "../../../../hooks/useRequestData";
import {getLeaseList} from "../../../../api/asset/AssetLeaseService";
import SearchSection from "../../../../components/search/SearchSection";
import Selector from "../../../../components/selector/Selector";
import {searchListener} from "../../../../components/commonmethod/simmsDrawerMethod";
import Search from "../../../../components/search/Search";
import SimmsInputSearch from "../../../../components/input/SimmsInputSearch";
import {extractObject} from "../../../../components/commonmethod/CommonMethod";
import DetailLinkedListView from "../../../../components/detailLayout/DetailLinkedListView";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../components/pageTabs/pageTabsStorage";

function AssetLease({id}) {
    const navigate = useNavigate();
    const {newData, pageInfo, dataHook} = useRequestData((conditions, pageable) => {
        const additionalCondition = {
            entityId: id,
        };
        const finalConditions = {
            ...conditions,
            ...additionalCondition,
        };
        return getLeaseList(finalConditions, pageable);
    }, {});

    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;

    const handleRowClick = (row) => {
        const rowId = row?.id;
        if (rowId == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "리스 상세"),
            url: `/asset/lease/${rowId}`,
        });
    };

    return (
        <DetailLinkedListView
            headerDefinition={ASSET_LEASE_HEADER}
            settingKey="lease"
            newData={newData}
            onPageChange={handleGridPageChange}
            onRowClick={handleRowClick}
        >
            <Search
                entity={"lease"}
                refresh={refresh}
                searchConditions={saveConditions}
                handleSearch={handleSearch}
                handlePageSizeChange={handlePageSizeChange}
                pageInfo={pageInfo}
                size
                detail
                searchBar={{placeHolder: "리스명, 리스 계약번호, 계약 차수"}}
            >
                <SearchSection>
                    <Selector
                        showLabel
                        onChange={(value) => searchListener(handleSearch, "company", extractObject(saveConditions), value)}
                        data={saveConditions.company}
                        entity={"company"}
                        title={"업체"}
                    >
                        <SimmsInputSearch type={"TEXT"} placeHolder={"업체명"} />
                    </Selector>
                </SearchSection>
            </Search>
        </DetailLinkedListView>
    );
}

export default AssetLease;
